var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileUploadIcon = function SvgFileUploadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5371 60C38.9996 60 37.7246 58.725 37.7246 57.1875V38.4375C37.7246 36.9 38.9996 35.625 40.5371 35.625C42.0746 35.625 43.3496 36.9 43.3496 38.4375V57.1875C43.3496 58.725 42.0746 60 40.5371 60Z",
    fill: "#918EB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6875 50.625H30.9375C29.4 50.625 28.125 49.35 28.125 47.8125C28.125 46.275 29.4 45 30.9375 45H49.6875C51.225 45 52.5 46.275 52.5 47.8125C52.5 49.35 51.225 50.625 49.6875 50.625Z",
    fill: "#918EB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0625 80.625H21.5625C5.025 80.625 0 75.6 0 59.0625V21.5625C0 5.025 5.025 0 21.5625 0H27.1875C33.75 0 35.8125 2.1375 38.4375 5.625L44.0625 13.125C45.3 14.775 45.4875 15 47.8125 15H59.0625C75.6 15 80.625 20.025 80.625 36.5625V59.0625C80.625 75.6 75.6 80.625 59.0625 80.625ZM21.5625 5.625C8.175 5.625 5.625 8.175 5.625 21.5625V59.0625C5.625 72.45 8.175 75 21.5625 75H59.0625C72.45 75 75 72.45 75 59.0625V36.5625C75 23.175 72.45 20.625 59.0625 20.625H47.8125C43.0125 20.625 41.4375 18.975 39.5625 16.5L33.9375 9C31.9875 6.4125 31.425 5.625 27.1875 5.625H21.5625Z",
    fill: "#918EB0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileUploadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-upload-icon.c526d7e4.svg";
export { ForwardRef as ReactComponent };